var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"vue-component component-error-notice"},[_vm._v(" Sorry, could not load user interface from server. Please try again. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }